import type * as models from './models'

/**
 * {@link https://ngrx.io/docs State} of this feature
 */
export interface State {
  /**
   * {@link State.Entry} for currently logged in
   * {@link models.User}
   */
  user?: State.Entry<models.User>
}
export namespace State {
  export const INITIAL: State = {
    // We start as if the user is loading since we know that we are going to
    // load it almost immediately, so it is smoother to just have it set as if
    // it is loading from the very beginning
    user: { isLoading: true },
  }

  export type Entry<T> = ExactlyOneOf<{
    data?: T
    isLoading?: boolean
    error?: Error
  }>
}
